
import {IElement, ITextAttributes, ITextSelectionInformation} from 'routes/private/Editor/types';
import { execCommandToSelectedText, updateRenderingTextSegments } from 'utils/textMultiStyling'

export const fontUppercaseResolver = ( element: IElement, value?: number, textSelectionInformation?: ITextSelectionInformation ) => {    
    if (element.type === "Text") {
        const attributes = execCommandToSelectedText("fontUpperCase", (element.attributes as ITextAttributes), textSelectionInformation, value);
        element.attributes = updateRenderingTextSegments(attributes);
    }
    return element;
}